class LinkResource {
	constructor(data, list) {
		this.id = data.item_id;
		this.name = data.item_name;
		this.type = data.item_type;
		this.graphicId = data.graphic_id;
		this.ownerId = data.owned_by;
		this.ownerName = data.owner_name;
		this.orderBy = this.order_by;

		this.list = list;
		this.copyOf = 0;

		this.rowElem = UI.listPlace([
			this.dragElem = UI.listRow([
				UI.div('drag-handle', null, {
					'mousedown touchstart': this.mousedown.bind(this)
				}),
				UI.img('list-row-graphic', graphicSrc(this.graphicId, AC.GRAPHIC_SML)),
				UI.div('flex-0', UI.icon(ITEM.NAMES[this.type], 30)),
				UI.div('flex-1', this.name),
				UI.div('flex-1', this.ownerName),
				UI.div('flex-0', [
					UI.priIconBtn('delete', 18, {
						'click': this.remove.bind(this)
					})
				])
			])
		]);

		// if (!this.isLinkable() && !this.isShareable()) this.copyOfSelf();
	}

	setList(list) {
		this.list = list;
	}
	isLinkable() {
		return true;
		return this.targetOwnerAccessMode >= AC.ACCESS_LIMITED;
	}
	isShareable() {
		return false;
		return this.userAccessMode === AC.ACCESS_OWNER;
	}
	copyOfSelf() {
		this.copyOf = 1;
		this.icons.innerHTML = '<i class="i-rg i-copy"></i>';
	}
	mousedown(ev) {
		this.list.list.prepDrag(this, ev);
	}
	remove() {
		this.list.list.removeItem(this);
	}
	getSaveData() {
		return [this.id, this.orderBy, this.copyOf || 0];
	}
	setPosition(pos) {
		this.orderBy = pos;
	}
}